import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityOrderListTemplate } from "themes/application/facility-order/pages";
import { FacilityOrderListViewStore } from "application/facility-order/stores";

@setCurrentView(rootStore => new FacilityOrderListViewStore(rootStore), "facilityOrderListViewStore")
@observer
class FacilityOrderList extends React.Component {
    render() {
        return <FacilityOrderListTemplate {...this.props} />;
    }
}

export default FacilityOrderList;